import { Release } from '@common/types/release/release';
import moment from 'moment';

export const getReleaseDate = (release?: Partial<Release>): string => {
  const date = release?.releaseDate;

  if (!date) {
    return '';
  }

  return moment(date).format('LL');
};

export const getPreviousReleaseDate = (release?: Partial<Release>): string => {
  const date = release?.previousReleaseDate;

  if (!date) {
    return '';
  }

  return moment(date).format('LL');
};

export const getPreorderDate = (release?: Partial<Release>): string => {
  const date = release?.preorderDate;

  if (!date) {
    return '';
  }

  return moment(date).format('L');
};
